import React, {useCallback, useEffect} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {Footer} from "../../Components/Layout/Footer";
import {Loading} from "../../Components/Loading";
import {NotifyUser} from "../../Components/Notifications";
import {ContextPropsConsumer} from "../../Components/StateManager";
import {contexts, useAppContext, useUserContext} from "../../Components/StateManager/Context";
import {scrollToTop} from "../../Utilities/commonUtilities";
import {locations} from "../../Utilities/Location";
import {LayoutPrint, TemplateBasicHeader} from "../../Components/Layout";
import {Authorize} from "../../Components/Authorize";

interface PageSetupProps {
    component?: React.FC<any>;
    isPrint?: boolean;
    path?: string;
    template?: React.FC<any>;
    showOwnCatalogLink?: boolean;
    showLoanLibraryCatalogLink?: boolean;
    [key: string]: any;
}

export const PageSetup: React.FC<PageSetupProps> = (props) => {

    let {
        component: Component,
        isPrint,
        path,
        template: Template = isPrint ? LayoutPrint : TemplateBasicHeader,
    } = props;

    const navigate = useNavigate();
    const location = useLocation();

    const handleReturnRedirect = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    const redirect = useCallback((route: string, replace = false) => {
        navigate(route, {replace});
    }, [navigate]);

    const pathUrl = location.pathname;
    const pathSearch = location.search;

    const {isLoadingCss, handleApiCall} = useAppContext();
    const {isLoggedIn, user, userId, fetchUser} = useUserContext();


    path = !path ? locations.NOT_FOUND.path : path;

    const params = useParams();

    const contextProps = {
        fetchUser,
        handleApiCall,
        handleReturnRedirect,
        isLoggedIn,
        location,
        navigate,
        ...params,
        path,
        pathUrl,
        pathSearch,
        redirect,
        user,
        userId,
    };

    useEffect(scrollToTop, [location.pathname]);

    if (isLoadingCss) return null;

    return <>
        <Template {...props} {...contextProps} {...params}>
            <ContextPropsConsumer contexts={contexts} props={contextProps}>
                {Loading}
                {NotifyUser}
                {Authorize}
                {Component && Component}

            </ContextPropsConsumer>
        </Template>
        {
            !isPrint &&
            <Footer/>
        }
    </>;
};
